import { useEffect, useRef } from 'react'

import Text from '../../elements/Typo/Text'

interface InformationDialogProps {
    buttonRef: any
    message: string
    toggleDialog: (e?: any) => void
}
const InfoDialog = (props: InformationDialogProps) => {
    const { buttonRef, message, toggleDialog } = props
    const dialogRef = useRef<HTMLDivElement>(null) // Create a ref for the dialog

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dialogRef.current && !dialogRef.current.contains(event.target as Node) && buttonRef.current && !buttonRef.current.contains(event.target)) {
                //     toggleDialog(); // Call the toggleDialog function if clicked outside
                toggleDialog()
            }
        }

        const rect = buttonRef.current.getBoundingClientRect()
        console.log('rect: ', rect)
        const top = rect.top + window.scrollY + rect.height + 10 // 10px below the clicked area
        const left = rect.left + window.scrollX
        console.log('top: ', top, ' left: ', left)

        console.log('buttonRef: ', buttonRef, ' ', buttonRef.current, ' window.scrollY: ', window.scrollY)

        // Attach the event listener
        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            // Clean up the event listener on component unmount
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [buttonRef, toggleDialog])

    return (
        <div
            ref={dialogRef}
            className="absolute z-10 px-2 py-2 bg-white border border-gray-300 rounded-[0.625rem] shadow-1 w-48 max-w-md"
            style={{
                top: buttonRef.current ? buttonRef.current.offsetTop : 0, //position.top,
                left: buttonRef.current ? buttonRef.current.offsetLeft + 300 : 0, //position.left
            }}
        >
            <div className="rounded-[0.625rem]">
                <Text>{message}</Text>
            </div>
        </div>
    )
}

export default InfoDialog
